import { history } from 'store';

export function navigateTo(pathname: string) {
  history.push({
    pathname,
  });
}

export function viewportHeight() {
  const viewportHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0
  );
  return viewportHeight;
}

export function setCookie(
  cName: string,
  cValue: string,
  expDays: number,
  path = ''
) {
  const d = new Date();
  d.setTime(d.getTime() + expDays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cName}=${cValue};${expires};path=/${path}`;
}

export function removeCookie(cName: string) {
  const d = new Date();
  d.setTime(d.getTime() + -1000 * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cName}=;${expires}`;
}

export function getCookie(cName: string) {
  const name = `${cName}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function currencyUSDFormat(value: number): string {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  });

  return formatter.format(value);
}

export const switchCase =
  (cases: any) => (defaultCase: string) => (key: string) => {
    return cases.hasOwnProperty(key) ? cases[key] : defaultCase;
  };

export async function asyncForEach(array: any, callback: any) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}
